import { IAppState } from '@store';
import { createSelector, createAsyncSelector } from '@flux';


const selectAsyncSessionContext = createAsyncSelector<ClientSessionContext, IAppState>({
	get: state => state.shared.context,
	selector: createSelector(
		(state: IAppState) => state.shared.context.item,
		item => item
	),
});

function selectSessionTenantName(state: IAppState) {
	return selectAsyncSessionContext.selectIsLoaded(state)
		? selectAsyncSessionContext.selectItem(state).SessionTenant.Name
		: '';
}

export const contextSelectorsPack = {
	selectAsyncSessionContext,
	selectSessionTenantName,
};
